import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { enqueueSnackbar } from 'notistack';
import axiosClient from 'api/config/axios';
import { adaptDisputeEvidence } from 'api/escrow/adapters';

type Params = {
  disputeId: string;
  file: File;
  description?: string;
};

async function uploadEvidence(params: Params) {
  const formData = new FormData();
  formData.append('file', params.file);
  if (params.description !== undefined) {
    formData.append('description', params.description);
  }

  const result = await axiosClient.mutate.post(`/api/v1/escrow/cases/${params.disputeId}/upload-evidence`, formData);
  return adaptDisputeEvidence(result.data.evidence);
}

const mutationKey = ['escrow', 'upload-evidence'] as const;

export function useUploadEvidenceMutation() {
  return useMutation({
    mutationKey,
    mutationFn: uploadEvidence,
    onError: (err?: AxiosError<{ success: false; message: string | Record<string, string[]> }>) => {
      const data = err?.response?.data;
      const message = data?.message;

      if (message && typeof message === 'object') {
        const firstField = Object.values(message)[0];
        const errorText = Array.isArray(firstField) ? firstField[0] : String(firstField);
        enqueueSnackbar(errorText || 'Unable to upload evidence. Check file type and size.', { variant: 'error' });
      } else {
        enqueueSnackbar(
          (typeof message === 'string' ? message : null) || 'Unable to upload evidence. Check file type and size.',
          { variant: 'warning' },
        );
      }
    },
  });
}
